export const SET_STOREHOUSE = "SET_STOREHOUSE";
export const SET_RECEIPT_ORDERS = "SET_RECEIPT_ORDERS";
export const SET_DINMEL_PRICES = "SET_DINMEL_PRICES";
